export default {
  props: {
    tag: {
      type: Object,
      required: true
    },
    parent: {
      type: Object,
      required: true
    }
  }
};
